import {Column,Entity,PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn, OneToMany, JoinColumn, ManyToOne } from "typeorm";
import { Item } from "../items/item.entity";
import {ItemCategory} from '../item-categories/item-categories.entity';

@Entity('sizes')
export class Sizes {

  @PrimaryGeneratedColumn("increment",{name:'size_id'})
  sizeId:number;
 
  @Column("varchar",{
      nullable:false,
      length:40,
      name:"size_name"
      })
      sizeName:string;

  @Column("int",{
    nullable:true,
    name:"item_category_id"
    })
    itemCategoryId: number;

    @Column("int",{
      nullable:true,
      name:"item_sub_category_id"
      })
      itemSubCategoryId: number;

  @Column("int",{
      nullable:true,
      name:"item_id"
      })
      itemId: number;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
  
  @OneToMany(type=>Item, item=>item.sizeInfo)
  itemInfo:Item[];

  // @OneToMany(type => ItemCategory, (itemCategory) => itemCategory.sizeInfo)
  // itemCategoryInfo: ItemCategory[];

  // @ManyToOne(type => ItemCategory, itemCategory => itemCategory.itemInfo, { nullable: false, })
  // @JoinColumn({ name: "item_category_id" })
  // itemCategoryId: ItemCategory;

  // @ManyToOne(type => Item, item => item.itemId, { nullable: false, })
  // @JoinColumn({ name: "item_id" })
  // itemId: Item;
 
}